// extracted by mini-css-extract-plugin
export var listResources = "ListResources-module--list-resources--6qOGc";
export var noResults = "ListResources-module--no-results--1-QZW";